export default __webpack_public_path__ + "images/QI.4285ca9.png";